import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import useInvalidateShop from "./use-invalidate-shop";

export default function useSetReturnToStoreActivation(shopId: string) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shopId);

  const mutation = $api.useMutation("put", "/shops/{shopId}/return-to-store/stores/activation");

  return useMutation({
    onSuccess: () => {
      successNotification();
      invalidateShop();
    },
    onError: () => {
      errorNotification();
    },

    mutationFn: async (active: boolean) => {
      return mutation.mutateAsync({ 
        params: { path: { shopId } },
        body: { active } 
      });
    },
  });
}
